import { ListingBannerItem } from '@/features/CMS/banners/types';
import { ProductListRowItem } from '@/features/products/components/list/productListSection/types';
import { ProductListingItem } from '@/features/products/types/product';

const BANNER_SLOTS = [
  { position: 5, minProductsToShow: 4 },
  { position: 10, minProductsToShow: 9 },
  { position: 16, minProductsToShow: 15 }
];

const BANNERS_PER_PAGE = BANNER_SLOTS.length;

export const injectListingBanners = (
  products: ProductListingItem[],
  listingBanners: ListingBannerItem[],
  page: number
): ProductListRowItem[] => {
  const items: ProductListRowItem[] = [...products];
  const pageIndex = page ? page - 1 : 0;

  listingBanners
    .slice(pageIndex * BANNERS_PER_PAGE, (pageIndex + 1) * BANNERS_PER_PAGE)
    .map((banner, index) => ({ banner, ...BANNER_SLOTS[index] }))
    .reverse()
    .forEach(({ banner, position, minProductsToShow }) => {
      if (products.length >= minProductsToShow) {
        items.splice(position, 0, banner);
      }
    });

  return items;
};
